/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlScheduledReminderCountQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GqlScheduledReminderCountQuery = {
  __typename: "Query";
  scheduledReminderCount: number;
};

export const ScheduledReminderCountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "scheduledReminderCount" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "scheduledReminderCount" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GqlScheduledReminderCountQuery,
  GqlScheduledReminderCountQueryVariables
>;
